import { useEffect, useState } from "react"

/**
 * Значение с задержкой — для того, что уходит на сервер по каждой букве.
 *
 * Ввод в поле остаётся мгновенным (само поле живёт на своём состоянии), а
 * запрос уезжает, только когда человек перестал печатать: иначе «3300007» — это
 * семь запросов через границу вместо одного.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
	const [delayed, setDelayed] = useState(value)

	useEffect(() => {
		const timer = setTimeout(() => setDelayed(value), delayMs)
		return () => clearTimeout(timer)
	}, [value, delayMs])

	return delayed
}
